import { z } from 'zod';

import { UserPlanZod } from 'types/zod/user-plan';

export const UserZod = z.object({
    user_id: z.number(),
    aws_id: z.string(),
    plan: UserPlanZod.optional(),
    expert_mode: z.boolean(),
    isEmailMfaEnabled: z.boolean().optional(),
});
export type User = z.infer<typeof UserZod>;
